import {RestResource} from '../rest'

import { WORK_ORDER_SERVER } from '../server'
import { athubAxios } from "../../util";

const workOrder = new RestResource({server: WORK_ORDER_SERVER, resource: 'eamWorkorder'});

workOrder._modifyAdditionInfoUrl = [workOrder.server, workOrder.resource, '{id}', 'addition'].join('/');
workOrder.modifyAdditionInfo = function(id, model, athubConfig) {
  return athubAxios.put(workOrder._modifyAdditionInfoUrl.replace('{id}', id), model, athubConfig);
};

//问题整改统计
workOrder.queryWtzg = (params) => {
    let url = `${WORK_ORDER_SERVER}/report/monthly/work/pbreform/close/rate`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.result);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

/**
 * 工单（变更）等级统计
 * @param params
 * @returns {Promise<unknown>}
 */
workOrder.levelStatistics = (params) => {
    let url = `${WORK_ORDER_SERVER}/eamWorkorder/level/statistics?dcnums=${params.dcnums}&date=${params.date}&type=${params.type}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.result);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

/**
 * 变更完成率变更完成率
 * @param params
 * @returns {Promise<unknown>}
 */
workOrder.onTimeChangeOrderTake = (params) => {
    let url = `${WORK_ORDER_SERVER}/report/monthly/change/close/rate`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.result);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

/**
 * 工单完成情况
 * @param params
 * @returns {Promise<unknown>}
 */
workOrder.monthReportWork = (params) => {
    let url = `${WORK_ORDER_SERVER}/report/monthly/work`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.result);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

/**
 * 变更成功率
 * @param params
 * @returns {Promise<unknown>}
 */
workOrder.monthReportChange = (params) => {
    let url = `${WORK_ORDER_SERVER}/report/monthly/change`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.result);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

workOrder.findSimpleByLogbook = (body) => {
    let url = `${WORK_ORDER_SERVER}/${workOrder.resource}/byLogbook/simple`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, body).then(responseBody => {
            if (responseBody.status === 200) {
                resolve(responseBody.data.result);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

workOrder.monthlyFinishRate = function(){
  return athubAxios.get(`${WORK_ORDER_SERVER}/big-screen-api/workorder/finish-rate`);
};

workOrder.monthlyWorkTypeStatistic = function () {
  return athubAxios.get(`${WORK_ORDER_SERVER}/big-screen-api/workorder/work-type`);
};

workOrder.page = (params) => {
    let url = `${WORK_ORDER_SERVER}/eamWorkorder/page`;
    return athubAxios.post(url, params);
};

export default workOrder;
